import React from 'react';
import { Link } from 'react-router-dom';
import { usePagesTextes, TexteRiche } from '../hooks/useFormTextes';

/**
 * Iter 154L — Charte officielle de placement dans les autocars.
 * Iter 179 (Kamel) — chaque voyageur choisit lui-même ses places via « Mon Bus ».
 * Iter 767 (Kamel) — textes éditables depuis l'admin (Site internet → Textes du site → Pages voyage).
 */
const Section = ({ n, title, children }) => (
  <section className="mb-7" data-testid={`charte-section-${n}`}>
    <h2 className="text-lg sm:text-xl font-bold text-[#1E3A5F] mb-2 flex items-baseline gap-2">
      <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-[#5BC5D4] text-white text-sm font-bold">{n}</span>
      {title}
    </h2>
    <div className="pl-9 text-sm sm:text-[15px] text-gray-700 leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function ChartePlacementBus() {
  const T = usePagesTextes();
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-8 sm:py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-md p-6 sm:p-10" data-testid="charte-placement-page">
        <div className="text-center mb-8 pb-6 border-b-2 border-gray-100">
          <div className="text-5xl mb-2">🚌</div>
          <h1 className="text-2xl sm:text-3xl font-bold text-[#1E3A5F] leading-tight">Charte de placement</h1>
          <p className="text-base sm:text-lg text-[#5BC5D4] font-semibold mt-1">Transport en autocar</p>
          <p className="text-xs text-gray-500 mt-3 italic">Rhône Alpes Amitié Voyages — applicable à tous les voyageurs sans exception</p>
        </div>

        <div className="text-sm text-gray-800 mb-6 leading-relaxed bg-sky-50 border border-sky-200 rounded-lg p-4" data-testid="charte-nouvelle-politique">
          <TexteRiche texte={T('charte_intro')} />
        </div>

        {[1, 2, 3, 4].map(n => (
          <Section key={n} n={n} title={T(`charte_s${n}_titre`)}>
            <TexteRiche texte={T(`charte_s${n}`)} className="space-y-2" liClassName="mt-1" />
          </Section>
        ))}

        <Section n={5} title={T('charte_s5_titre')}>
          <div className="bg-[#1E3A5F] text-white rounded-lg p-4 -ml-9">
            <TexteRiche texte={T('charte_s5')} className="space-y-2 text-sm" />
          </div>
        </Section>

        <div className="text-center mt-10 pt-6 border-t-2 border-gray-100">
          <Link to="/inscription" className="inline-block bg-[#5BC5D4] hover:bg-[#4ab0bd] text-white font-bold px-6 py-3 rounded-full transition shadow-md" data-testid="charte-go-inscription">
            J&apos;ai lu — Aller au formulaire d&apos;inscription →
          </Link>
          <p className="text-xs text-gray-500 mt-4">Rhône Alpes Amitié Voyages — pour voyager seul, entre amis ou en famille</p>
        </div>
      </div>
    </div>
  );
}
